import React, { useEffect, useState } from "react";
import {
  Typography,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import apiClient from "../../services/apiClient";
import SEO from "../../components/SEO";

export default function AdminEmailsPage() {
  const [data, setData] = useState({ rows: [] });

  const load = () => {
    apiClient.request("/api/admin/emails").then(setData);
  };

  useEffect(() => {
    load();
  }, []);

  const retry = async (id) => {
    await apiClient.request(`/api/admin/emails/${id}/retry`, { method: "POST" });
    load();
  };
  const cancel = async (id) => {
    await apiClient.request(`/api/admin/emails/${id}/cancel`, { method: "POST" });
    load();
  };

  return (
    <>
      <SEO title="Admin Emails | DigiBuddy" noIndex noFollow />
      <Typography variant="h4" sx={{ mb: 1 }}>5. Emails</Typography>
      <Typography variant="body2" sx={{ mb: 2, color: "text.secondary" }}>
        Suivi des emails automatiques du CRM entrants (scheduled/sent/failed).
      </Typography>
      <Paper sx={{ overflow: "auto" }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell>Lead</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Statut</TableCell>
              <TableCell>Planifie</TableCell>
              <TableCell>Envoye</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.rows?.map((row) => (
              <TableRow key={row.id}>
                <TableCell>{row.lead?.email}</TableCell>
                <TableCell>{row.email_type}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.scheduled_at ? new Date(row.scheduled_at).toLocaleString() : "-"}</TableCell>
                <TableCell>{row.sent_at ? new Date(row.sent_at).toLocaleString() : "-"}</TableCell>
                <TableCell>
                  {row.status === "failed" && <Button size="small" onClick={() => retry(row.id)}>Relancer</Button>}
                  {row.status === "scheduled" && <Button size="small" color="warning" onClick={() => cancel(row.id)}>Annuler</Button>}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </>
  );
}
